import axiosPost from '../axiosPost';

export const localidadesDel = async (arg) => {
    const { id } = arg;

    const body = {
        "service": "LocalidadDel",
        "params": {
            "localidadId": id
        }
    }

    try {
        const result = await axiosPost('Y', body, arg)
        console.log(result.data)
        return result.data
    } catch (err) {
        console.log(err)
    }
}